import { createUseStyles } from 'react-jss';
import { mechaColours } from '../mecha_styles';

export const useStyles = createUseStyles({
    // TODO: add support for md and sm sizes as necessary
    // Hero button
    mecha_hero_button_lg: () => ({
        height: '5.6rem',
        width: '268px',
        fontSize: '1.8rem',
        fontWeight: '700',
        '@media only screen and (max-width: 600px)': {
            fontSize: '1.6rem',
        }
    }),
    mecha_hero_button: {
        backgroundColor: mechaColours.buttonHero,
        borderColor: mechaColours.borderPrimary,
        color: mechaColours.contentPrimary,
        borderRadius: '100rem',
        border: '0.2rem solid',
        maxHeight: '5.6rem',
        '&:active': {
            backgroundColor: mechaColours.buttonHeroPressed,
            boxShadow: `0rem 0rem 0rem 0.4rem ${mechaColours.buttonHeroPressed}`
        },
        '&:hover': {
            backgroundColor: mechaColours.buttonHeroHover,
            cursor: 'pointer'
        },
        '&:disabled': {
            backgroundColor: mechaColours.buttonBackgroundDisabled,
            color: mechaColours.buttonContentDisabled,
            border: 'none',
            boxShadow: 'none',
            cursor: 'default'
        }
    },
    mecha_white_hero_button: {
        backgroundColor: mechaColours.buttonWhiteHero,
        borderColor: mechaColours.borderPrimary,
        color: mechaColours.contentPrimary,
        borderRadius: '100rem',
        border: '0.2rem solid',
        maxHeight: '5.6rem',
        display: 'block',
        margin: '0 auto',
        '&:active': {
            backgroundColor: mechaColours.buttonWhiteHeroPressed,
            boxShadow: `0rem 0rem 0rem 0.4rem ${mechaColours.buttonWhiteHeroPressed}`
        },
        '&:hover': {
            backgroundColor: mechaColours.buttonWhiteHeroHover,
            cursor: 'pointer'
        },
        '&:disabled': {
            backgroundColor: mechaColours.buttonBackgroundDisabled,
            color: mechaColours.buttonContentDisabled,
            border: 'none',
            boxShadow: 'none',
            cursor: 'default'
        }
    },
    mecha_white_hero_button_lg: (() => ({
        height: '5.6rem',
        width: '26.8rem',
        fontSize: '1.8rem',
        fontWeight: '700',
        '@media only screen and (max-width: 600px)': {
            fontSize: '1.6rem',
            height: '4.8rem'
        }
    })),
    // Primary button
    // TODO: add support for md and sm sizes as necessary
    // Primary button
    mecha_primary_button_lg: (({ isXs }) => ({
        height: isXs ? '4rem' : '4.8rem',
        width: '28.4rem',
        fontSize: isXs ? '1.4rem' : '1.6rem',
        fontWeight: '700'
    })),
    mecha_primary_button_xs: ({ isXs }) => ({
        height: '4rem',
        width: '18rem',
        fontSize: isXs ? '1.4rem' : '1.6rem',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly'
    }),
    mecha_primary_button: ({ isXs }) => ({
        backgroundColor: mechaColours.primaryMediumBlue,
        color: mechaColours.primaryTextColor,
        borderRadius: '100rem',
        maxHeight: '5.6rem',
        marginBottom: '0.4rem',
        '&:active': {
            backgroundColor: mechaColours.primaryDarkBlue,
            borderColor: mechaColours.primaryDarkBlue,
            height: isXs ? '4rem' : '4.8rem',
            border: '0.2rem solid',
            padding: '',
            boxShadow: `0rem 0rem 0rem 0.4rem ${mechaColours.primaryDarkBlue}`
        },
        '&:hover': {
            backgroundColor: mechaColours.primaryDarkBlue,
            cursor: 'pointer'
        },
        '&:disabled': {
            backgroundColor: mechaColours.buttonBackgroundDisabled,
            color: mechaColours.buttonContentDisabled,
            border: 'none',
            boxShadow: 'none',
            cursor: 'default'
        }
    }),

    // Text button
    mecha_text_button_lg: () => ({
        height: '5.6rem',
        width: '23.5rem',
        fontSize: '1.8rem',
        fontWeight: '700',
        '@media only screen and (max-width: 600px)': {
            height: '4.8rem',
            fontSize: '1.6rem',
            width: '100%'
        }
    }),
    mecha_text_button: {
        backgroundColor: 'transparent',
        color: mechaColours.linkPrimary,
        borderRadius: '100rem',
        maxHeight: '5.6rem',
        '&:active': {
            backgroundColor: mechaColours.buttonTextPressed
        },
        '&:hover': {
            backgroundColor: mechaColours.buttonTextHover,
            cursor: 'pointer'
        },
        '&:disabled': {
            backgroundColor: mechaColours.buttonBackgroundDisabled,
            color: mechaColours.buttonContentDisabled,
            border: 'none',
            boxShadow: 'none',
            cursor: 'default'
        }
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    mecha_blue: {
        backgroundColor: mechaColours.primaryMediumBlue,
        color: '#FCFCFB',
        '&:hover': {
            backgroundColor: mechaColours.primaryDarkBlue,
            cursor: 'pointer'
        }
    }
});
